import { combineReducers } from "redux";
import browseImagesReducer from "./browseImages";
import telemedicineReducer from "./telemedicine";
import bbNewUploadReducer from "./bbNewUpload";
import findProviderReducer from "./findProvider";
import findProvidersResultReducer from "./findProvidersResult";
import providerDetailsReducer from "./providerDetails";
import myFavoritesReducer from "./myFavorites";
import submitFeedbackReducer from "./submitFeedback";
import searchURLReducer from "./searchURL";
import submitBillsReducer from "./submitBills";
import favoriteProviderReducer from "./favoriteProvider";
import procedureDetailsReducer from "./procedureDetails";
import procedureQuestionnaireReducer from "./procedureQuestionnaire";
import submitProcedureShopperReducer from "./submitProcedureShopper";
import fetchCurrentLocationReducer from "./fetchCurrentLocation";
import appConfigReducer from "./appConfig";
import parseAccessTokenReducer from "./parseAccessToken";
import disputeAuthorizationReducer from "./disputeAuthorization";
import bestContactInfoReducer from "./bestContactInfo";
import submitContactInformationReducer from "./submitContactInformation";
import fetchDocumentTypesReducer from "./fetchDocumentTypes";
import submitBalanceBillingClaimReducer from "./submitBalanceBillingClaim";
import fetchUserInfoReducer from "./fetchUserInfo";
import fetchBalanceBilingStatusReducer from "./fetchBalanceBillingStatus";
import fetchBalanceBillingHistoryForUserReducer from "./fetchBalanceBillingHistoryForUser";
import fetchBalanceBillingClaimStatusReducer from "./fetchBalanceBillingClaimStatus";
import fetchBBClaimDetailsReducer from "./fetchBBClaimDetails";
import authReducer from "./authReducer";
import fetchMyPlansDocumentsReducer from "./fetchMyPlansDocuments";
import fetchQualityScoreCategoriesReducer from "./fetchQualityScoreCategories";
import fetchQualityScoreCategoryIdReducer from "./fetchQualityScoreCategoryId";
import fetchAllClaimsReducer from "./fetchAllClaims";
import setBalanceBillViewState from "./setBalanceBillViewState";
import oneTimeSignatureAddressesReducer from "./oneTimeSignatureAddreses";
import submitDAFReducer from "./submitDAF";
import submitUpdatedAddressReducer from "./submitUpdatedAddress";
import updatedAddressReducer from "./updatedAddress";
import fetchGroupSpecificContractsReducer from "./fetchGroupSpecificContracts"
import drexiLoginReducer from "./drexiLogin";
import fetchAccessTokenReducer from "./fetchAccessToken";

const rootReducer = combineReducers({
  browseImages: browseImagesReducer,
  telemedicine: telemedicineReducer,
  bbNewUpload: bbNewUploadReducer,
  findProvider: findProviderReducer,
  providersResult: findProvidersResultReducer,
  providerDetails: providerDetailsReducer,
  myFavorites: myFavoritesReducer,
  submitFeedback: submitFeedbackReducer,
  searchURL: searchURLReducer,
  submitBills: submitBillsReducer,
  favoriteProvider: favoriteProviderReducer,
  procedureDetails: procedureDetailsReducer,
  procedureQuestionnaire: procedureQuestionnaireReducer,
  submitProcedureShopper: submitProcedureShopperReducer,
  fetchCurrentLocation: fetchCurrentLocationReducer,
  appConfig: appConfigReducer,
  parseAccessToken: parseAccessTokenReducer,
  disputeAuthorization: disputeAuthorizationReducer,
  bestContactInfo: bestContactInfoReducer,
  submitContactInformation: submitContactInformationReducer,
  fetchDocumentTypes: fetchDocumentTypesReducer,
  submitBalanceBillingClaim: submitBalanceBillingClaimReducer,
  fetchUserInfo: fetchUserInfoReducer,
  fetchBalanceBillingStatus: fetchBalanceBilingStatusReducer,
  fetchBalanceBillingHistoryForUser: fetchBalanceBillingHistoryForUserReducer,
  fetchBalanceBillingClaimStatus: fetchBalanceBillingClaimStatusReducer,
  fetchBBClaimDetails: fetchBBClaimDetailsReducer,
  authReducer: authReducer,
  fetchMyPlansDocuments: fetchMyPlansDocumentsReducer,
  fetchQualityScoreCategories: fetchQualityScoreCategoriesReducer,
  fetchQualityScoreCategoryId: fetchQualityScoreCategoryIdReducer,
  fetchAllClaims: fetchAllClaimsReducer,
  setBalanceBillViewState: setBalanceBillViewState,
  oneTimeSignatureAddresses: oneTimeSignatureAddressesReducer,
  submitDAF: submitDAFReducer,
  submitUpdatedAddress: submitUpdatedAddressReducer,
  updatedAddress: updatedAddressReducer,
  fetchGroupSpecificContracts:fetchGroupSpecificContractsReducer,
  drexiLogin: drexiLoginReducer,
  fetchAccessToken: fetchAccessTokenReducer,
});

export default rootReducer;
